import React from 'react';

import styles from './InactiveTimeoutModal.module.less';
import Button from '../Buttons/Button';

/*
    process.env.STORYBOOK_ENV is set when calling the storybook run or build
    commands in package.json.

    It should not be used for regular unit testing or storyshot testing.

    Only env variables starting with `STORYBOOK_` get passed to storybook,
    hence the naming.

    process.env.NO_TIMEOUT is set in the webpack config during hotloading
    and can be disabled with the `--withTimeout` flag.
*/

const noTimeout = process.env.STORYBOOK_ENV || process.env.NO_TIMEOUT;

// TODO - move to a shared folder of some variety

export class InactiveTimeoutModal extends React.Component {
    state = {
        startTime: null,
        interval: null,
        loggingOut: false,
        tickTock: true
    };
    componentDidMount() {
        this._isMounted = true;
        // If we're in hotload / storybook, do not set any timers
        if (noTimeout) return;
        this.listenForIdle();
        this.resetTimer();
        const interval = setInterval(this.updateTime.bind(this), 1000);

        this.setState({
            interval: interval
        });
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearInterval(this.state.interval);
    }
    listenForIdle() {
        let lastUpdate = new Date(0);
        const throttledReset = () => {
            if (new Date() - lastUpdate < 400) return;
            lastUpdate = new Date();
            //only reset the timer if there is activity *before* modal appears.
            if (this.modalVisible()) return;
            this.resetTimer();
        };
        document.addEventListener('keydown', throttledReset);
        document.addEventListener('click', throttledReset);
        document.addEventListener('mousemove', throttledReset);
    }
    resetTimer() {
        if (this._isMounted) {
            this.setState(
                {
                    startTime: new Date()
                },
                () => this.updateTime()
            );
        }
    }
    updateTime() {
        if (this.timeRemaining() == 0) return this.logOut();
        if (this._isMounted) {
            this.setState({ tickTock: !this.state.tickTock });
        }
    }
    logOut() {
        clearInterval(this.state.interval);
        if (this._isMounted) {
            this.setState({ loggingOut: true });
        }
        return this.props.handleLogout();
    }
    elapsedSeconds() {
        const { _forceNow } = this.props;
        const now = _forceNow ? _forceNow : new Date();
        return Math.floor((now - this.state.startTime) / 1000);
    }
    modalVisible() {
        const { modalAppearTime, timeLimit } = this.props;
        //If modal time not set, show after 2/3 of time limit has elapsed.
        const appearTime = modalAppearTime || Math.floor(timeLimit * 0.66);
        return appearTime - this.elapsedSeconds() <= 0;
    }
    timeRemaining() {
        //don't return negative seconds
        return Math.max(0, this.props.timeLimit - this.elapsedSeconds());
    }
    render() {
        if (noTimeout)
            return (
                <div className="no-timeout" style={{ display: 'none' }}>
                    Inactive Timeout Modal Placeholder
                </div>
            );
        const { loggingOut } = this.state;
        const remainingTime = this.timeRemaining();
        const plural = remainingTime == 1 ? '' : 's';

        const body = () => {
            if (loggingOut)
                return (
                    <div className={styles['content']}>
                        <p>Logging out...</p>
                    </div>
                );

            return (
                <div className={styles['content']}>
                    <h1>Are you still there?</h1>
                    <p>
                        You will be logged out in {remainingTime} second{plural}
                        .
                    </p>
                    <Button
                        onClick={this.resetTimer.bind(this)}
                        kind="secondary"
                        text="Continue Session"
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button
                        onClick={this.logOut.bind(this)}
                        kind="secondary"
                        text="Log Out"
                    />
                </div>
            );
        };
        return (
            // TODO - is this ok accessiblity-wise?
            this.modalVisible() && (
                <div
                    id="inactive-timeout"
                    data-testid="inactive-timeout"
                    className={styles['container']}
                >
                    {body()}
                </div>
            )
        );
    }
}

InactiveTimeoutModal.defaultProps = {
    timeLimit: 180
};
